<template>
  <div class="sitePage">
    <el-table
          stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80:50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
        prop="code"
        label="代码"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.code">{{scope.row.code}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name">{{scope.row.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.enable"
            class="item"
            effect="dark"
            content="禁用"
            placement="top"
            :open-delay="300"
          >
            <i @click="disableSite($event, scope.row)" class="iconfont icon-qiyong"></i>
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="启用"
            placement="top"
            :open-delay="300"
          >
            <i @click="enableSite($event, scope.row)" class="iconfont icon-jinyong"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="上移" placement="top" :open-delay="300">
            <i @click="moveUpSite($event, scope.row)" class="el-icon-arrow-up"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="下移" placement="top" :open-delay="300">
            <i @click="moveDownSite($event, scope.row)" class="el-icon-arrow-down"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getProductionActionSearch"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {
  apiProductionActionSearch,
  apiProductionActionDisable,
  apiProductionActionEnable,
  apiProductionActionMoveUp,
  apiProductionActionMoveDown
} from "@/api/factoryTools.js";

export default {
  components: {
    pagination
  },
  props: {
    siteSearchForm: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      }
    };
  },
  methods: {
    // 表格数据
    async getProductionActionSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProductionActionSearch({
        ...this.siteSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if(callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProductionActionSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProductionActionSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProductionActionSearch();
    },
    // 禁用
    disableSite(e, row) {
			e.target.blur();
      this.$allOperation(row, "禁用", "站点").then(async () => {
        const res = await apiProductionActionDisable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductionActionSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success"
          });
        }
      });
    },
    // 启用
    enableSite(e, row) {
			e.target.blur();
      this.$allOperation(row, "启用", "站点").then(async () => {
        const res = await apiProductionActionEnable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductionActionSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success"
          });
        }
      });
    },
    // 上移
    moveUpSite(e, row) {
			e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移站点", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiProductionActionMoveUp({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductionActionSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success"
          });
        }
      });
    },
    // 下移
    moveDownSite(e, row) {
			e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移站点", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiProductionActionMoveDown({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getProductionActionSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scope>
.sitePage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>